<template>
  <div class="list">
    <!-- header-title -->
    <div class="header-title flex-row flex__between margin-bottom-10">
      <div class="leftSection flex-row flex__left">
        <div class="theTitle theTitle__lv5 flex-row flex__center">STT</div>
        <div class="theTitle theTitle__lv1 flex-row flex__left padding-left-10">
          Tiêu đề
        </div>
      </div>

      <div class="rightSection flex-row flex__right">
        <div class="theTitle theTitle__lv2 flex-row flex__right">
          Người duyệt
        </div>

        <div class="theTitle theTitle__lv2 flex-row flex__right">
          Trạng thái
        </div>

        <div
          class="theTitle theTitle__lv2 flex-row flex__right padding-right-10"
          @click="sortByColumn('startTime')"
        >
          Ngày bắt đầu
          <sort-caret
            :order="currentCreateTimeOrder"
            :sort="currentSortBy"
            :field="'startTime'"
          />
        </div>

        <div
          class="theTitle theTitle__lv3 flex-row flex__right padding-right-10"
          @click="sortByColumn('createTime')"
        >
          Ngày tạo
          <sort-caret
            :order="currentCreateTimeOrder"
            :sort="currentSortBy"
            :field="'createTime'"
          />
        </div>
      </div>
    </div>
    <!-- list-docs -->
    <VuePerfectScrollbar
      class="scroll-area"
      :settings="perfectScrollbarSetting"
      infinite-wrapper
    >
      <div class="list-docs">
        <div
          class="item flex-row flex__between clickable"
          v-for="(item, $itemIndex) in this.data"
          v-bind:key="$itemIndex"
          @click="viewDetail(item)"
        >
          <div class="leftSection flex-row flex__left ">
            <div class="theTitle__lv5">
              <div class="flex-row flex__left">
                <div class="section-check">
                  <span class="stt flex-row flex__center">{{
                    $itemIndex + 1
                  }}</span>
                </div>
                <img
                  class="icon-small"
                  src="../../../assets/img/symbol/doc.svg"
                  alt
                />
              </div>
            </div>
            <div class="theTitle__lv1 margin-right-10">
              <div class="title-docs flex-col flex__left">
                <div class="tt_1 clickable">{{ item.meetingTitle }}</div>
                <div class="tt_2 flex-row flex__left margin-top-10">
                  <span>{{ item.meetingPlace }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="rightSection flex-row flex__right">
            <div
              class="theTitle__lv3 flex-row flex__right padding-right-10 font-size__small"
            >
              <div class="flex-row flex__right">
                {{ item.approveUserName || 'Chưa có người duyệt' }}
              </div>
            </div>
            <!--            region Tình trạng phê duyệt-->
            <div
              class="theTitle__lv2  flex-row flex__right padding-right-10 font-size__small"
              style="margin-right: -13px"
            >
              <div class="flex-row flex__center ">
                <el-tag
                  v-if="item.approveStatus === 'Tạm phê duyệt'"
                  size="mini"
                  :class="['priority', 'lv3']"
                >
                  {{ item.approveStatus }}
                </el-tag>
              </div>
              <div class="flex-row flex__center">
                <el-tag
                  v-if="item.approveStatus === 'Chưa phê duyệt'"
                  size="mini"
                  :class="['priority', 'lv2']"
                >
                  {{ item.approveStatus }}
                </el-tag>
              </div>
              <div class="flex-row flex__center">
                <el-tag
                  v-if="item.approveStatus === 'Đã ban hành'"
                  size="mini"
                  :class="['priority', 'lv4']"
                >
                  {{ item.approveStatus }}
                </el-tag>
              </div>
              <div class="flex-row flex__center">
                <el-tag
                  v-if="item.approveStatus === 'Hủy yêu cầu'"
                  size="mini"
                  :class="['priority', 'lv1']"
                >
                  {{ item.approveStatus }}
                </el-tag>
              </div>
              <div class="flex-row flex__center">
                <el-tag
                  v-if="item.approveStatus === 'Không phê duyệt'"
                  size="mini"
                  :class="['priority', 'lv1']"
                >
                  {{ item.approveStatus }}
                </el-tag>
              </div>
            </div>
            <!--            test-->

            <!--region Ngày bắt đầu-->
            <div
              class="theTitle__lv2 flex-row flex__right padding-right-10 font-size__small"
            >
              <div class="flex-row flex__right">
                <span>{{
                  item.startTime | dateFormatter({ nullValue: "-" })
                }}</span
                >&nbsp;&nbsp;
              </div>
            </div>
            <!--endregion-->

            <!--region Ngày tạo-->
            <div
              class="theTitle__lv3 flex-row flex__right padding-right-10 font-size__small"
            >
              <div class="flex-row flex__right">
                <span>{{
                  item.createTime | dateFormatter({ nullValue: "-" })
                }}</span
                >&nbsp;&nbsp;
                <div
                  :class="[
                    'theDueDate',
                    item.status === 'DANGXULY'
                      ? 'lv2'
                      : item.status === 'HOANTHANH'
                      ? 'lv3'
                      : item.status === 'HUY'
                      ? 'lv1'
                      : ''
                  ]"
                ></div>
              </div>
            </div>
            <!--endregion-->
          </div>
        </div>

        <infinite-loading
          ref="infiniteLoading"
          spinner="spiral"
          @infinite="infiniteHandler"
          force-use-infinite-wrapper=".el-table__body-wrapper"
        >
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
        <div class="flex-row flex__center" v-if="this.data.length === 0">
          Không có dữ liệu
        </div>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import dateFormatter from "../../../filters/dateFormatter";
import SortCaret from "../../doc-out/SortCaret";

export default {
  name: "LichTuan_MainContent",
  props: ["data"],
  components: {
    VuePerfectScrollbar,
    SortCaret
  },
  filters: { dateFormatter },
  methods: {
    sortByColumn(columName) {
      this.currentCreateTimeOrder =
        this.currentCreateTimeOrder === "desc" ? "asc" : "desc";
      this.currentSortBy = columName;
      this.$emit("sortByColumn", {
        sortBy: this.currentSortBy,
        sortOrder: this.currentCreateTimeOrder
      });
    },

    viewDetail(item) {
      this.$emit("viewDetail", {
        caseMasterId: item.caseMasterId
      });
    },
    infiniteHandler($state) {
      this.$emit("infiniteHandler", $state);
    }
  },
  data() {
    return {
      currentSortBy: "startTime",
      currentCreateTimeOrder: "desc"
    };
  },
  watch: {
    data(newValue) {
      if (newValue !== this.data) {
        this.data = newValue;
      }
    }
  }
};
</script>

<style scoped>
.list {
  /* height: calc(100% - 50px - 15px) !important; */
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/lichtuan/LichTuan_MainContent.vue